// removed by extract-text-webpack-plugin
module.exports = {"post":"listing__post___2k52i","body":"listing__body___2U6Cr","publishedAt":"listing__publishedAt___9ouii","cover":"listing__cover___1IQog","title":"listing__title___FiVQe","teaser":"listing__teaser___22Djd","readOn":"listing__readOn___Y0UfM","moreLink":"listing__moreLink___1T7KF","fadein":"listing__fadein___kH0yF"};


//////////////////
// WEBPACK FOOTER
// ./src/components/posts/listing.scss
// module id = 394
// module chunks = 0